import { MDSText, MDSTextColor, MDSTextProps, MDSTextVariant, MDSTextWeight } from "@/mds";
import styled from "@emotion/styled";

interface EmptyTextProps extends MDSTextProps {
  children: React.ReactNode;
}

export function EmptyText({ children, ...props }: EmptyTextProps): JSX.Element {
  return (
    <StyledText
      variant={MDSTextVariant.TextM}
      weight={MDSTextWeight.Smedium}
      color={MDSTextColor.Secondary}
      {...props}
    >
      {children}
    </StyledText>
  );
}

const StyledText = styled(MDSText)`
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing[1]};
`;
